import { render } from "./deploy.vue?vue&type=template&id=9b2c0572"
import script from "./deploy.vue?vue&type=script&lang=ts"
export * from "./deploy.vue?vue&type=script&lang=ts"

import "./deploy.vue?vue&type=style&index=0&id=9b2c0572&lang=css"
script.render = render

export default script